"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCondition = exports.validatesCondition = exports.evalCondition = exports.isExactly = exports.hasAllOf = exports.hasAnyOf = exports.has = exports.isAnyOf = exports.isEqual = exports.isTrue = void 0;
const lodash_1 = require("lodash");
function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'YES' || value === 'OUI';
}
exports.isTrue = isTrue;
function isEqual(v1, v2) {
    return (isTrue(v1) && isTrue(v2)) || v1 === v2 || '' + v1 === '' + v2;
}
exports.isEqual = isEqual;
function isEmpty(value) {
    return (value === '' ||
        value === undefined ||
        value === null ||
        (Array.isArray(value) && value.length === 0));
}
function contains(haystack, needle) {
    if (!haystack)
        return false;
    if (!needle)
        return false;
    if (typeof haystack === 'string') {
        return haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1;
    }
    else if (Array.isArray(haystack)) {
        return haystack.indexOf(needle) !== -1;
    }
    return false;
}
function isAnyOf(value, valuesToFind) {
    if (!valuesToFind)
        return true;
    if (!value)
        return false;
    return valuesToFind.includes(value);
}
exports.isAnyOf = isAnyOf;
function has(array, valueToFind) {
    if (isEmpty(array) || !Array.isArray(array))
        return false;
    if (!valueToFind)
        return true;
    return array.includes(valueToFind);
}
exports.has = has;
function hasAnyOf(array, valuesToFind) {
    if (!valuesToFind)
        return true;
    if (isEmpty(array) || !Array.isArray(array))
        return false;
    return (0, lodash_1.some)(array, (v) => isAnyOf(v, valuesToFind));
}
exports.hasAnyOf = hasAnyOf;
function hasAllOf(array, valuesToFind) {
    if (isEmpty(valuesToFind))
        return true;
    if (!Array.isArray(valuesToFind) || !Array.isArray(array))
        return false;
    if (array.length < valuesToFind.length)
        return false;
    return (0, lodash_1.every)(valuesToFind, (v) => isAnyOf(v, array));
}
exports.hasAllOf = hasAllOf;
function isExactly(array, valuesToFind) {
    if (isEmpty(array)) {
        return isEmpty(valuesToFind);
    }
    if (isEmpty(valuesToFind))
        return false;
    if (!Array.isArray(array) || !Array.isArray(valuesToFind))
        return false;
    if (array.length !== valuesToFind.length)
        return false;
    // TODO: handle duplicates in one of the arrays ? :/
    return (0, lodash_1.every)(array, (item) => isAnyOf(item, valuesToFind));
}
exports.isExactly = isExactly;
function ensureNumber(value) {
    if (typeof value === 'number')
        return value;
    if (typeof value === 'string')
        return parseFloat(value);
    return NaN;
}
function evalCondition(condition, object) {
    if (!condition)
        return true;
    if (typeof condition !== 'object') {
        return condition(object);
    }
    const { op } = condition;
    if (op === 'and' || op === 'or') {
        const { expressions } = condition;
        if (!expressions || expressions.length === 0)
            return true;
        if (op === 'and') {
            return (0, lodash_1.every)(expressions, (exp) => evalCondition(exp, object));
        }
        else {
            return (0, lodash_1.some)(expressions, (exp) => evalCondition(exp, object));
        }
    }
    const { key, value } = condition;
    const objValue = (0, lodash_1.get)(object, key);
    switch (op) {
        case 'isEqual': {
            if (Array.isArray(objValue) && !Array.isArray(value)) {
                // Matching array with not array
                return !!objValue.find((v) => isEqual(v, value));
            }
            return isEqual(objValue, value);
        }
        case 'isNotEqual':
            return !isEqual(objValue, value);
        case 'isEmpty':
            return !objValue;
        case 'isNotEmpty':
            return !!objValue;
        case 'isAnyOf':
            return isAnyOf(objValue, value);
        case 'isNoneOf':
            return !isAnyOf(objValue, value);
        case 'hasAnyOf':
            return hasAnyOf(objValue, value);
        case 'hasNoneOf':
            return !hasAnyOf(objValue, value);
        case 'hasAllOf':
            return hasAllOf(objValue, value);
        case 'isExactly':
            return isExactly(objValue, value);
        case 'has':
            return has(objValue, value);
        case 'doesntHave':
            return !has(objValue, value);
        case 'contains':
            return contains(objValue, value);
        case 'doesntContain':
            return !contains(objValue, value);
        case '>':
        case '<':
        case '>=':
        case '<=': {
            if (isEmpty(objValue) || isEmpty(value))
                return false;
            const leftValue = ensureNumber(objValue);
            if (isNaN(leftValue))
                return false;
            switch (condition.op) {
                case '>':
                    return leftValue > value;
                case '<':
                    return leftValue < value;
                case '>=':
                    return leftValue >= value;
                case '<=':
                    return leftValue <= value;
            }
        }
        default: {
            console.warn('unknown op', condition.op);
            return false;
        }
    }
}
exports.evalCondition = evalCondition;
function validatesCondition(condition, item) {
    return evalCondition(condition, item);
}
exports.validatesCondition = validatesCondition;
function buildCondition(condition) {
    if (!condition)
        return () => true; // noop
    return (item) => evalCondition(condition, item);
}
exports.buildCondition = buildCondition;
//# sourceMappingURL=utils.js.map